import React from "react";

import styles from "../styles/opening-hours.module.scss";

import ROLES from "data/Roles";
import { UserStorage } from "shared/tools/UserStorage";
import { EnvironmentsAPI } from "../providers/EnvironmentsAPI";
import { Button } from "../shared/components/Button";
import { Title } from "../shared/components/Title";
import Day from "../shared/containers/WorkingTime/Day";
import WorkingTime from "../shared/plugins/core/schema/configurations/WorkingTime";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";

export default class OpeningHours extends React.Component {
  constructor(props) {
    super(props);

    this.changeDay = this.changeDay.bind(this);
    this.changeDayStatus = this.changeDayStatus.bind(this);

    this.state = {
      workingTime: { days: [] },
      environment: {},
    };
  }

  componentDidMount() {
    this.loadWorkingTime();
    this.setState({
      environment: EnvironmentStorage.getEnvironment(),
    });
  }

  async loadWorkingTime() {
    let workingTime = WorkingTime.getTemplatePeriodWeek(1, false);

    const environment_id = EnvironmentStorage.getSelectedEnvironment();
    const response = await EnvironmentsAPI.getConfigurationsWorkingTime(
      environment_id
    );

    const { days } = response.getData({ days: [] });
    if (days.length > 0) {
      [workingTime] = new WorkingTime([{ days }]).periods;
    }

    this.setState({
      workingTime: workingTime,
    });
  }

  changeDay(dayIndex, fields) {
    this.setState((state) => {
      const workingTime = { ...state.workingTime };

      workingTime.days[dayIndex] = {
        ...workingTime.days[dayIndex],
        ...fields,
      };

      return {
        workingTime: workingTime,
      };
    });
  }

  changeDayStatus(dayIndex, isActive) {
    this.changeDay(dayIndex, { active: isActive });

    const day = this.getDay(dayIndex);
    if (isActive === true && day.open.length === 0) {
      this.addPeriod(dayIndex);
    }
  }

  getDay(dayIndex) {
    const day = this.state.workingTime.days[dayIndex] || null;
    return day;
  }

  getAfterDay(dayIndex) {
    const day = this.getDay(dayIndex);
    let nextDay = null;
    if (day && day.nextDay && day.periodOfNextDay) {
      const nextWeekDay = Object.entries(day.periodOfNextDay).filter(
        ([weekDay, active]) => active === true
      )[0];
      nextDay = this.state.workingTime.days.find(
        (d) => d.weeknum === nextWeekDay && d.active === true
      );
    }

    return nextDay;
  }

  getBeforeDay(dayIndex) {
    const day = this.getDay(dayIndex);
    const nextDay = this.state.workingTime.days.find(
      (d) =>
        d.periodOfNextDay && d.periodOfNextDay[day.weeknum] && d.active === true
    );
    return nextDay;
  }

  addTime(time, value = 15) {
    const [hour, minutes] = String(time).split(":");
    const finalHour =
      parseInt(minutes, 10) === 45
        ? parseInt(hour, 10) + 1
        : parseInt(hour, 10);
    let finalMinutes = parseInt(minutes, 10) + value;
    finalMinutes = finalMinutes === 60 ? 0 : finalMinutes;

    return `${`${finalHour}`.padStart(2, "0")}:${`${finalMinutes}`.padStart(
      2,
      "0"
    )}`;
  }

  addPeriod(dayIndex) {
    const currentDay = this.state.workingTime.days[dayIndex];
    if (!currentDay.nextDay) {
      const lastCloseTime =
        currentDay.close[currentDay.close.length - 2] || null;
      const currentCloseTime =
        currentDay.close[currentDay.close.length - 1] || null;

      if (currentCloseTime === "23:45") {
        return;
      }

      let open = "08:00";
      let close = "08:15";
      if (currentCloseTime) {
        // iniciar após o fim do período anterior
        if (lastCloseTime) {
          open = this.addTime(lastCloseTime, 15);
          close = this.addTime(open, 15);
        } else {
          open = this.addTime(currentCloseTime, 15);
          close = this.addTime(open, 15);
        }
      } else {
        // continuar o período novo a partir do fim do dia anterior
        const previousDay = this.getBeforeDay(dayIndex);
        if (previousDay) {
          const previousCloseTime =
            currentDay.close[currentDay.close.length - 1] || null;
          if (previousCloseTime) {
            open = this.addTime(previousCloseTime, 15);
          }
        }
      }

      currentDay.open.push(open);
      currentDay.close.push(close);

      this.changeDay(dayIndex, {
        open: currentDay.open,
        close: currentDay.close,
      });
    }
  }

  changePeriod(dayIndex, periodIndex, field, value) {
    const day = this.getDay(dayIndex);

    if (["open", "close"].includes(field)) {
      const [hour, hasAfterDay] = value.split(" ");

      day[field][periodIndex] = hour;

      const isLastPeriod = periodIndex === day.open.length - 1;
      if (isLastPeriod) {
        if (hasAfterDay) {
          const nextDay = (day.weeknum + 1) % 7;
          day.nextDay = true;
          day.periodOfNextDay = {
            [nextDay]: true,
          };
        } else {
          day.nextDay = false;
          day.periodOfNextDay = null;
        }
      }

      this.changeDay(dayIndex, {
        [field]: day[field],
        nextDay: day.nextDay,
      });
    }
  }

  removePeriod(dayIndex, periodIndex) {
    const day = this.getDay(dayIndex);

    if (day.nextDay) {
      day.nextDay = false;
      day.periodOfNextDay = null;
    }

    day.open.splice(periodIndex, 1);
    day.close.splice(periodIndex, 1);

    this.changeDay(dayIndex, {
      open: day.open,
      close: day.close,
    });
  }

  clear() {
    const workingTime = WorkingTime.getTemplatePeriodWeek(1, false);

    this.setState({
      workingTime: workingTime,
    });
  }

  getNormalizedHours(hours) {
    return hours.map((hour) => hour.replace(":", ""));
  }

  getNormalizedWorkingTime() {
    const { workingTime } = this.state;
    const days = workingTime.days.map((day) => {
      return {
        ...day,
        open: this.getNormalizedHours(day.open),
        close: this.getNormalizedHours(day.close),
      };
    });

    return {
      days,
    };
  }

  async save() {
    this.setState({
      saveLoading: true,
    });

    try {
      const environment_id = EnvironmentStorage.getSelectedEnvironment();
      const payload = this.getNormalizedWorkingTime();
      const response = await EnvironmentsAPI.putConfigurationsWorkingTime(
        environment_id,
        payload
      );

      if (response.getErrors([]).length > 0) {
        alert({
          text: `Não foi possível alterar o horário de funcionamento: ${
            response.getErrors()[0]
          }`,
        });
      } else {
        alert({ text: "Alteração realizada com sucesso!" });
        const configurations = EnvironmentStorage.getConfigurations();
        EnvironmentStorage.setConfigurations({
          ...configurations,
          working_time: payload,
        });
        window.dispatchEvent(new CustomEvent("configurationUpdate"));
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({
        saveLoading: false,
      });
    }
  }

  render() {
    const { workingTime, saveLoading, environment } = this.state;

    const getSubtitle = () => {
      if (environment?.brand)
        return (
          `${environment.brand.name} - ${environment.name}` +
          (environment.active === false ? " (Inativa)" : "")
        );
      return environment?.name;
    };

    let userRole = UserStorage.getLoggedUser()?.role;
    if (!userRole) userRole = ROLES.SHOPKEEPER;

    const canUpdate = true;
    const canChangeStatus = true;

    return (
      <div className={styles.openingHoursContainer}>
        <Title
          title="Horários de atendimento"
          subtitle={getSubtitle()}
          backTo={{ url: "/configuracoes", name: "Configurações" }}
        >
          {canUpdate && (
            <Button design="primary" onClick={() => this.clear()}>
              Limpar
            </Button>
          )}
        </Title>

        <div className={styles.weekContainer}>
          {workingTime.days.map((day, dayIndex) => (
            <Day
              key={`day-${day.weeknum}`}
              active={day.active}
              weeknum={day.weeknum}
              nextDay={day.nextDay}
              close={day.close}
              open={day.open}
              readOnly={canUpdate === false}
              beforeDay={this.getBeforeDay(dayIndex)}
              afterDay={this.getAfterDay(dayIndex)}
              onChangeStatus={(isActive) =>
                canChangeStatus && this.changeDayStatus(dayIndex, isActive)
              }
              onChangePeriod={(periodIndex, field, value) =>
                canUpdate &&
                this.changePeriod(dayIndex, periodIndex, field, value)
              }
              onRemovePeriod={(periodIndex) =>
                canUpdate && this.removePeriod(dayIndex, periodIndex)
              }
              onAddPeriod={() => canUpdate && this.addPeriod(dayIndex)}
            />
          ))}
        </div>

        <div className={styles.save}>
          {(canUpdate || canChangeStatus) && (
            <Button
              design="primary"
              onClick={() => this.save()}
              className="w-100"
              loading={saveLoading}
            >
              Salvar
            </Button>
          )}
        </div>
      </div>
    );
  }
}
